import React from "react";
import cn from "classnames";
import PropTypes from "prop-types";
import { DataGridItem } from "components/data-grid";
import withStyles from "components/with-styles";
import Link, { ExternalLink } from "components/link";
import styles from "./styles/item-wrapper.css.js";

const ItemWrapper = ({ className, classes, children, disabled, url, externalUrl, ...props }) => {
  const LinkComponent = externalUrl ? ExternalLink : Link;
  return (
    <DataGridItem
      small
      className={cn(className, classes.centeredText, {
        [classes.disabledElement]: disabled,
        [classes.menuItem]: !disabled,
      })}
    >
      {disabled ? (
        <div>{children}</div>
      ) : (
        <LinkComponent className={classes.link} href={url} {...props}>
          <div>{children}</div>
        </LinkComponent>
      )}
    </DataGridItem>
  );
};

ItemWrapper.propTypes = {
  /**
   * Indica si es una url externa a tiivii
   */
  externalUrl: PropTypes.bool,
  /**
   * Clase adicional del componente.
   */
  className: PropTypes.string,
  /**
   * Indica si el elemento del menú está deshabilitado
   */
  disabled: PropTypes.bool,
  /**
   * Url del elemento de menú
   */
  url: PropTypes.string.isRequired,
};

export default withStyles(styles)(ItemWrapper);
